import type React from 'react';
import Icon from '2-core-elements/Icon/Icon';
import { formatDateRange } from 'utils/formatDateRange';

interface SearchItemMetadataProps {
    eventStartDate?: string;
    eventEndDate?: string;
    eventLocation?: string;
    newsPublishDate?: string;
}

const SearchItemMetadata: React.FC<SearchItemMetadataProps> = ({
    eventStartDate,
    eventEndDate,
    eventLocation,
    newsPublishDate,
}) => {
    const dateRange = formatDateRange(eventStartDate, eventEndDate);

    return (
        <div className="item-metadata">
            {eventStartDate && (
                <time className="item-date">
                    <Icon icon="calendar" />
                    {eventEndDate ? `${dateRange}` : eventStartDate}
                </time>
            )}
            {eventLocation && (
                <p className="item-location">
                    <Icon icon="location-on" /> {eventLocation}
                </p>
            )}
            {newsPublishDate && <time className="item-date">{newsPublishDate}</time>}
        </div>
    );
};

export default SearchItemMetadata;
